// Scroll reveal for home-* sections: [data-home-reveal] elements fade and rise into view.
// Only elements below the fold at load get hidden, so nothing visible flashes.
// Items parked off to the right of a horizontal scroller are left alone.

const HOME_REVEAL_STAGGER = 80
const HOME_REVEAL_GROUP = 4

const initHomeReveal = () => {
	let reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
	if (reducedMotion || window.Shopify?.designMode || !("IntersectionObserver" in window)) return

	let observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) return
			entry.target.classList.add("is-revealed")
			observer.unobserve(entry.target)
		})
	}, { threshold: 0.12 })

	document.querySelectorAll(".home-section").forEach(section => {
		let items = [...section.querySelectorAll("[data-home-reveal]")]

		items.forEach((item, i) => {
			let rect = item.getBoundingClientRect()
			// Skip what is already on screen, and cards parked to the right of a horizontal scroller
			if (rect.top < window.innerHeight || rect.left >= window.innerWidth) return
			item.style.setProperty("--home-reveal-delay", `${(i % HOME_REVEAL_GROUP) * HOME_REVEAL_STAGGER}ms`)
			item.classList.add("home-reveal")
			observer.observe(item)
		})
	})
}

if (!window.homeRevealLoaded) {
	window.homeRevealLoaded = true
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initHomeReveal)
	else initHomeReveal()
}
